import { render, staticRenderFns } from "./selectSentenceByVoice.vue?vue&type=template&id=f73370f0&scoped=true"
import script from "./selectSentenceByVoice.vue?vue&type=script&lang=js"
export * from "./selectSentenceByVoice.vue?vue&type=script&lang=js"
import style0 from "./selectSentenceByVoice.vue?vue&type=style&index=0&id=f73370f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73370f0",
  null
  
)

export default component.exports